module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['search-tree', _vm.no_border ? 'no-border' : ''],
    style: (_vm.tree_style)
  }, [(_vm.canClose) ? _c('ni-button', {
    staticClass: "right-block",
    attrs: {
      "icon": _vm.open_cust_icon,
      "button_style": _vm.button_style,
      "icon_style": _vm.icon_style
    },
    on: {
      "click": function($event) {
        _vm.open_cust = !_vm.open_cust
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_header) ? _c('el-row', [_c('el-row', {
    staticClass: "search-header"
  }, [_c('ni-input', {
    attrs: {
      "placeholder": "根据部门名称、人员姓名搜索"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search_data($event)
      }
    },
    model: {
      value: (_vm.search_tree_form.search_content),
      callback: function($$v) {
        _vm.$set(_vm.search_tree_form, "search_content", $$v)
      },
      expression: "search_tree_form.search_content"
    }
  }, [_c('ni-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search",
      "title": "查找部门"
    },
    on: {
      "click": _vm.search_data
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('ni-line')], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tree_loading),
      expression: "tree_loading"
    }],
    staticClass: "content-height",
    style: (_vm.content_style)
  }, [(_vm.tree_nodes.length > 0) ? _c('ni-tree', {
    ref: _vm.tree_ref,
    staticClass: "tree-body",
    attrs: {
      "nodes": _vm.tree_nodes,
      "setting": _vm.tree_setting
    }
  }) : (_vm.tree_nodes.length == 0 && !_vm.tree_loading) ? _c('ni-no-data') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-434d7d37","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/host-panel-tree/tree.vue
// module id = HTmq
// module chunks = 81